import React from "react";
import { Spinner } from "./Spinner";

export const ButtonAuth = ({ children, loader=null, onClick=null, index=null, className="w-44 lg:mb-5 lg:mt-5 mb-3 mt-3", disabled=false }) => {
  return (
    <button
      onClick={onClick}
      type="submit"
      className={`${className} rounded-full
                 bg-[#ff39b3] font-bold
                 p-2
                 text-white
                 
                 cursor-pointer
                 hover:bg-navy`}
      disabled={loader || disabled} // Disable the button when loader is true
    >
      {loader ? <Spinner className='flex w-full justify-center'/> : children}
    </button>
  );
};
